export default "__VITE_ASSET__DixRUGIF__"